<template>
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')"
          >重置</el-button>
        </div>
      </el-form-item>
      <el-form-item label="设置：">
        <draggable class="wrapper" v-model="curItem.data" :options="{ animation: 120, filter: '.drag__nomove' }">
          <div class="param-img-item" :key="itemindex" v-for="(navBar, itemindex) in curItem.data">
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="$parent.onEditorDeleleData(itemindex, selectedIndex)"></i>
            </div>
            <div class="url-box" style="width:300px;">
              <span class="key-name">文字内容：</span>
              <el-input v-model="navBar.text"></el-input>
            </div>
            <div class="url-box">
              <span class="key-name">颜色：</span>
              <div class="d-s-c">
                <el-color-picker v-model="navBar.color"></el-color-picker>
                <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置</el-button>
              </div>
            </div>

              <div>
              <span class="key-name">来源：</span>
              <el-radio-group v-model="navBar.source">
                <el-radio :label="'links'">链接</el-radio>

                <el-radio :label="'page'">页面</el-radio>
              </el-radio-group>
            </div>



                <div v-if="navBar.source=='page'">
              <div class="d-s-c">
                <div class="url-box flex-1">
                  <span class="key-name">页面名称：</span>
                  <el-input style="width:80px;" :value="navBar.name+navBar.linkUrl"></el-input>
                </div>
                <div class="url-box ml10">
                  <el-button type="primary" @click="changeLink(itemindex)">选择页面</el-button>
                </div>
              </div>
            </div>


            <div v-if="navBar.source=='links'">
              <div class="d-s-c">
                <div class="url-box flex-1">
                  <span class="key-name">链接名称：</span>
                  <el-input style="width:80px;" :value="navBar.name+navBar.linkUrl"></el-input>
                </div>
                <div class="url-box ml10">
                  <el-button type="primary" @click="changeLink(itemindex)">选择链接</el-button>
                </div>
              </div>
            </div>
            <div v-else-if="navBar.source=='goods'">
               <div class="d-s-c">
                <div class="choice-product-list">
                  <draggable v-model="navBar.goodsdata" :options= "{draggable:'.item',animation:500}">
                    <transition-group class="d-s-c f-w">
                      <div  v-for="(product, index) in navBar.goodsdata" class="item" :id="itemindex+'_'+product.product_id" :key="product.product_id">
                        <div class="delete-box"><i class="el-icon-error" @click="deleleGoodsData(itemindex+'_'+product.product_id,index,itemindex,selectedIndex)"></i></div>
                        <img v-img-url="product.image" alt="" />
                      </div>
                    </transition-group>
                  </draggable>
                </div>
                <div>
                  <el-button icon="el-icon-plus" @click="changeProduct(itemindex,navBar.goodsdata)">选择产品</el-button>
                </div>
              </div>
            </div>
            <div v-else-if="navBar.source=='categorys'">
              <el-form-item label="商品分类：">
                <el-cascader class="ww100" v-model="navBar.category" v-if="CategoryList.length > 0"   :options="CategoryList" :props="{ checkStrictly: true, children: 'child', value: 'category_id', label: 'name' }" @change="changeCategory($event,itemindex)"></el-cascader>
              </el-form-item>

              <el-form-item label="商品排序：">
                <el-radio-group v-model="navBar.productSort">
                  <el-radio :label="'all'">综合</el-radio>
                  <el-radio :label="'sales'">销量</el-radio>
                  <el-radio :label="'price'">价格</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="显示数量："><el-input v-model="navBar.showNum" class="w-auto"></el-input></el-form-item>
            </div>
            <!-- 组件样式 -->
            <div v-if="navBar.source=='categorys'||navBar.source=='goods'">
              <div class="p-10-0 mb16 f14 border-b"><span class="gray6">组件样式</span></div>

               <!-- 商品排序 -->
              <el-form-item label="分列数量：">
                <el-radio-group v-model="navBar.show.column">
                  <el-radio :label="1" :disabled="navBar.show.display == 'slide'">单列</el-radio>
                  <el-radio :label="2">两列</el-radio>
                  <el-radio :label="3">三列</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 商品排序 -->
              <el-form-item label="商品排序：">
                <el-radio-group v-model="navBar.show.display">
                  <el-radio :label="'list'">列表平铺</el-radio>
                  <el-radio :label="'slide'" :disabled="navBar.show.column == 1">横向滑动</el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- 商品排序 -->
              <el-form-item label="显示内容：">
                <el-checkbox v-model="navBar.show.productName" @change="checked => check(checked, 'productName',itemindex)">商品名称</el-checkbox>
                <el-checkbox v-model="navBar.show.productPrice" @change="checked => check(checked, 'productPrice',itemindex)">商品价格</el-checkbox>
                <el-checkbox v-model="navBar.show.linePrice" @change="checked => check(checked, 'linePrice',itemindex)">划线价格</el-checkbox>
                <el-checkbox v-model="navBar.show.directCommission" @change="checked => check(checked, 'directCommission',itemindex)">直推收益</el-checkbox>
                <el-checkbox v-model="navBar.show.sellingPoint" @change="checked => check(checked, 'sellingPoint',itemindex)" v-show="navBar.show.column == 1">商品卖点</el-checkbox>
                <el-checkbox v-model="navBar.show.productSales" @change="checked => check(checked, 'productSales',itemindex)" v-show="navBar.show.column == 1">商品销量</el-checkbox>
              </el-form-item>
          </div>

          </div>
        </draggable>
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
    <ProductSelect :isproduct="isproduct" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeProduct($event)">选择产品</ProductSelect>
  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
import Setlink from "@/components/setlink/Setlink";
import draggable from "vuedraggable";
import ProductSelect from '@/components/product/Product';
export default {
  components: {
    Setlink,
    draggable,
    ProductSelect
  },
  data() {
    return {
      /*是否选择链接*/
      is_linkset: false,
      index: null,
      isproduct: false,
      /*商品需要去重的*/
      excludeIds: [],
      /*是否多选*/
      islist: false,
      /*商品类别*/
      CategoryList: [],
    };
  },
  props: ["curItem", "selectedIndex", "opts"],
  // watch: {
  //     curItem: function(n, o) {
  //     if (n&&n != o) {
  //       console.log(1234);
  //       this.curItem =n;
  //     }
  //   }
  // },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取商品*/
    getData() {
      let self = this;
      ProductApi.catList(
        {
          page_id: self.page_id
        },
        true
      )
        .then(res => {
          self.CategoryList = res.data.list;
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

     /*选择产品*/
    changeProduct(index,list) {
      this.isproduct = true;
      this.index = index;
      let arr = [];
      if(list==undefined){
        list = [];
      }
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      //多选
      this.islist = true;

      this.isproduct = true;
    },

    /*商品选择关闭弹窗*/
    closeProduct(e) {
      this.isproduct = false;
      if (e.type == 'success') {
        if(this.curItem.data[this.index].goodsdata==undefined){
          this.curItem.data[this.index].goodsdata = [];
        }


        this.curItem.data[this.index].goodsdata = this.curItem.data[this.index].goodsdata.concat(e.params);
        // let product_arr = [];
        // this.curItem.data[this.index].goodsdata.forEach(item => {
        //   console.log(item);
        //   product_arr.push(item.product_id);
        // });
        // this.curItem.data[this.index].product_arr = product_arr;
      }
    },
    /* 删除 */
    deleleGoodsData(id,index,itemindex,selectedIndex) {

      let self = this;
      this.index=  itemindex;
     // document.getElementById(id).style.display='none';
      this.curItem.data[this.index].goodsdata.splice(index, 1);
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if(e!=null){
        this.curItem.data[this.index].linkUrl = e.url;
        this.curItem.data[this.index].name = "链接到" + " " + e.type + " " + e.name;
        if (e.appid) {
          this.curItem.data[this.index].appid = e.appid;
        }
      }
    },

    /*检查*/
    check(checked, name,itemindex) {
      let value = checked ? true : false;
      this.index=  itemindex;
      this.curItem.data[itemindex].show[name] = value;
    },

     /*选择类别*/
    changeCategory(e,itemindex) {
      this.itemindex = itemindex;
      let arrlength = e.length-1;
      this.curItem.data[itemindex].category = e[arrlength];
    }
  },
};
</script>

<style>
.choice-product-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.choice-product-list .item {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
}

.choice-product-list .item .delete-box {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -10px;
  right: -10px;
  font-size: 20px;
  cursor: pointer;
  color: #999999;
}

.choice-product-list .item .delete-box:hover {
  color: rgb(255, 51, 0);
}

.choice-product-list .item.plus-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.choice-product-list .item.plus-btn > i {
  font-size: 30px;
  color: #cccccc;
}

.choice-product-list img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Option.vue